import {AuthService, ErrorHandler,MovieService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'

export default {
    name: 'activate',
    data(){
        return {
            loading: true,
            related_movies:[],
            movies:[],
            activationLoading:false,
            activationDialog:false
        }
    },

    methods:{

        resendActivation(){
            this.activationLoading = false;
            AuthService.resendActivation().then(()=>{
                this.activationDialog = true;
                this.activationLoading = false;
            })
        },

        getRelatedMovies(movies, user) {

            if (!user || user.isGuest() || user.PreferredGenres.length ==0){
                let m = movies.data;
                return m;
            };

            let filteredMovies = []
            movies.data.reduce((c, movie)=> {
                movie.genres.forEach((genre)=> {
                    user.PreferredGenres.forEach((prefGen)=> {
                        if (genre.id == prefGen) {
                            filteredMovies.push(movie)
                        }
                    })
                })
            })
            return filteredMovies
        },
    },

    created(){
        Promise.all([AuthService.user(),MovieService.getMovies()]).then(([user,movies])=> {

            this.related_movies = this.getRelatedMovies(movies,user);
            this.movies = movies.data;
            // console.log(this.related_movies,movies);
            ErrorHandler.ignoreNextError();
            if (user.isGuest()) {
                this.$router.push("/user/login?redirect=/user/activate/" + this.$route.params.activationCode);
            } else
                AuthService.activateMember(this.$route.params.activationCode).then(
                    (r)=> {
                        this.loading = false;
                        if(!r.success) this.error=true
                        user.setActivated(true);
                    }
                    , (e)=> {
                        this.loading = false;
                        this.error = true;
                    })
        })

    }
}


// WEBPACK FOOTER //
// ./src/components/pages/user/activate.js